import { memo } from 'react';
import classnames from 'classnames';
import { useRouteMatch } from 'react-router-dom';
import Breadcrumbs from 'components/Breadcrumbs';
import MenuContainer from './MenuContainer';
import NavList from './NavList';
import useStyles from './style';
import { IModulePageTemplateProps } from './types';

function ModulePageTemplate({
  breadcrumbConfig,
  className,
  children,
  menuConfig,
}: IModulePageTemplateProps) {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const displayMenu = !!menuConfig?.length;

  return (
    <div className={classnames(classes.root, className)}>
      {displayMenu && (
        <MenuContainer>
          <div className={classnames(classes.scrollWrapper, classes.menu)}>
            <nav
              className={classnames(classes.scrollableContainer, classes.navMenu)}
              data-testid="navigation-menu"
            >
              <NavList basePath={path} items={menuConfig} />
            </nav>
          </div>
        </MenuContainer>
      )}
      <div className={classnames(classes.scrollWrapper, classes.content)}>
        <div className={classes.scrollableContainer}>
          <Breadcrumbs routesConfig={breadcrumbConfig} className={classes.breadcrumb} />
          {children}
        </div>
      </div>
    </div>
  );
}

export default memo(ModulePageTemplate);
